import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Telecharge un fichier depuis une URL sans quitter l'onglet courant (pas de nouvel onglet,
 * pas de perte de navigation SPA sur mobile). Recupere le contenu en blob puis declenche un
 * telechargement natif via un lien temporaire; si le fetch echoue (ex: CORS), on se rabat sur
 * une navigation dans le meme onglet.
 */
export async function downloadFileFromUrl(url: string, filename: string) {
  try {
    const response = await fetch(url)
    if (!response.ok) throw new Error("Download failed")
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = blobUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(blobUrl)
  } catch {
    window.location.assign(url)
  }
}
